import { __extends } from "tslib";
import { getLogPositiveMin, log } from '../util/math';
import Continuous from './base';
/**
 * Log åº¦éï¼å¤çéåååå¸
 */
var Log = /** @class */ (function (_super) {
    __extends(Log, _super);
    function Log() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        return _this;
    }
    /**
     * @override
     */
    Log.prototype.invert = function (value) {
        var base = this.base;
        var max = log(base, this.max);
        var rangeMin = this.rangeMin();
        var range = this.rangeMax() - rangeMin;
        var min;
        var positiveMin = this.positiveMin;
        if (positiveMin) {
            if (value === 0) {
                return 0;
            }
            min = log(base, positiveMin / base);
            var appendPercent = (1 / (max - min)) * range; // 0 å° positiveMinçå æ¯
            if (value < appendPercent) {
                // è½å° 0 - positiveMin ä¹é´
                return (value / appendPercent) * positiveMin;
            }
        }
        else {
            min = log(base, this.min);
        }
        var percent = (value - rangeMin) / range;
        var tmp = percent * (max - min) + min;
        return Math.pow(base, tmp);
    };
    Log.prototype.initCfg = function () {
        this.tickMethod = 'log';
        this.base = 10;
        this.tickCount = 6;
        this.nice = true;
    };
    // è®¾ç½®
    Log.prototype.setDomain = function () {
        _super.prototype.setDomain.call(this);
        var min = this.min;
        if (min < 0) {
            throw new Error('When you use log scale, the minimum value must be greater than zero!');
        }
        if (min === 0) {
            this.positiveMin = getLogPositiveMin(this.values, this.base, this.max);
        }
    };
    // æ ¹æ®å½åå¼è·åå æ¯
    Log.prototype.getScalePercent = function (value) {
        var max = this.max;
        var min = this.min;
        if (max === min) {
            return 0;
        }
        // å¦æå¼å°äºç­äº0ï¼åæç§0å¤ç
        if (value <= 0) {
            return 0;
        }
        var base = this.base;
        var positiveMin = this.positiveMin;
        // å¦æmin == 0, åæ ¹æ®æ¯0å¤§çæå°å¼ï¼è®¡ç®æ¯ä¾å³ç³»ãè¿ä¸ªæå°å¼ä½ä¸ºåæ è½´ä¸çç¬¬äºä¸ªtickï¼ç¬¬ä¸ä¸ªæ¯0ä½æ¯ä¸æ¾ç¤º
        if (positiveMin) {
            min = (positiveMin * 1) / base;
        }
        var percent;
        // å¦ææ°å¼å°äºæ¬¡å°å¼ï¼é£ä¹å°±è®¡ç® value / æ¬¡å°å¼ å æ´ä½çæ¯ä¾
        if (value < positiveMin) {
            percent = value / positiveMin / (log(base, max) - log(base, min));
        }
        else {
            percent = (log(base, value) - log(base, min)) / (log(base, max) - log(base, min));
        }
        return percent;
    };
    return Log;
}(Continuous));
export default Log;
//# sourceMappingURL=log.js.map